import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FolderAction } from './actions/folder.action';
import { OrderAction } from './actions/order.action';
import { CartInterface } from '../../shared/models/cart/cart.interface';
import { ActionInterface } from './actions/action.interface';
import { Cart } from '../../shared/models/cart/cart.model';
import { CeContextService, PlatformContextService } from '../../shared/services/context';
import { CeService } from '../../shared/services/ce.service';
import { Observable } from 'rxjs/Observable';
import { PaymentService } from '../../shared/services/payment.service';
import { LoadingService } from '../../shared/services/loading.service';
import { MessageService } from '../../shared/services/message.service';
import { NavController } from 'ionic-angular';
import { ToastDirective } from '../../shared/directives/toast/toast';
import { Folder } from '../../shared/models/folder/folder.model';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { File } from '@ionic-native/file';
import { CompteBancaireService } from '../../shared/services/compteBancaire.service';
import { Folders } from '../../shared/models/folder/folder.interface';
import { ParamCeRepositoryService } from '../../shared/services/repository/symfony-api';
import { BeneficiaireInterface } from '../../shared/models/beneficiaire/beneficiaire.interface';
import FolderInterface = Folders.FolderInterface;
import * as moment from 'moment';
import { ModeleEcheancier } from '../../shared/models/modeleEcheancier/modeleEcheancier.model';
import { MoyenPaiementForm } from '../../shared/models/moyenPaiement/moyen-paiement-form';
import { BeneficiairesService } from '../../shared/services/beneficiaires.service';
import { mergeMap, tap } from 'rxjs/operators';
import { ActiviteInterface } from '../../shared/models/activite/activite.interface';
import { ProduitsService } from '../../shared/services/produits.service';

@Component({
  selector: 'core-payment',
  templateUrl: './payment.component.html'
})
export class PaymentComponent implements OnInit {
  @Input() public object: CartInterface | FolderInterface = null;
  @Input() public beneficiaire: BeneficiaireInterface = null;
  @Output() public paymentSucced = new EventEmitter<boolean>();
  @Output() public canceled = new EventEmitter<any>();
  @Output() public paidLater = new EventEmitter<any>();

  public isComponentReady = false;
  private delegateService: ActionInterface = null;
  public paymentList: Array<any> = [];
  public modelPayment: any = {};
  public modelPaymentMore: any = {};
  public modeleEchancier: ModeleEcheancier;
  private paiementDiffereExplicite: boolean;
  private paramCeDatePaiementVide: boolean;
  private messageValidationCommandeSalarie: string;
  public imageCamera = null;
  private disabledBtn: boolean = false;
  public formErrors: any = {};
  public base64Image: string;
  public isReimboursement: boolean = false;
  public compteBancaires: Array<any>;
  public maxDate;
  public maxDateRemiseDeCheque;
  public modeleEcheancierList: Array<ModeleEcheancier> = [];
  public paymentForm = MoyenPaiementForm.FormEnum;
  public selectedPayment: MoyenPaiementForm.FormEnum;
  public selectedPaymentIsSepa: boolean = false;
  public currentBeneficiaire: BeneficiaireInterface = null;
  private selectedPaymentIsPrlSal: boolean;

  public constructor(
    private folderAction: FolderAction,
    private orderAction: OrderAction,
    public platformContextService: PlatformContextService,
    private ceContext: CeContextService,
    private ceService: CeService,
    private paymentService: PaymentService,
    private loadingService: LoadingService,
    private messageService: MessageService,
    private navCtrl: NavController,
    private toast: ToastDirective,
    private camera: Camera,
    private file: File,
    private compteBancaireService: CompteBancaireService,
    private paramCeRepositoryService: ParamCeRepositoryService,
    private beneficiairesService: BeneficiairesService,
    private readonly produitsService: ProduitsService
  ) {
  }

  ngOnInit(): void {
    if (this.object instanceof Cart) {
      this.delegateService = this.orderAction;
      this.modelPayment.montantTotal = this.object.restantApayer;
    } else if (this.object instanceof Folder) {
      this.delegateService = this.folderAction;
      this.modelPayment.montantTotal = this.object.montantTrigger;
      this.isReimboursement = true;
    } else {
      throw new Error('Object not supported for payment!');
    }

    this.maxDate = moment(this.object.date).add(1, 'years').format('YYYY-MM-DD');
    this.maxDateRemiseDeCheque = this.platformContextService.isElu() ? this.maxDate : moment(this.object.date).year();

    if (this.beneficiaire === null || this.beneficiaire === undefined) {
      throw new Error('Required parameter beneficiaire was null or undefined.');
    }
    // On récupère le benef pour avoir son RIB à jour
    this.beneficiairesService.getBeneficiaire(this.beneficiaire.id).subscribe(response => {
      this.currentBeneficiaire = response;
      console.log((this.currentBeneficiaire as any).iban);
    });

    this.paramCeRepositoryService.getParamCeByCeId(this.ceContext.get().id)
      .pipe(
        tap(data => {
          this.paiementDiffereExplicite = data.paiementDiffereExplicite;
          this.messageValidationCommandeSalarie = data.messageValidationCommandeSalarie;
          this.paramCeDatePaiementVide = data.datePaiementVide;
        }),
        mergeMap(() => this.delegateService.getAvailablePayment(this.object))
      )
      .subscribe(data => {
        this.paymentList = data;
        // Selected first payment by default
        if (this.paymentList.length > 0) {
          this.modelPayment.id = this.paymentList[0].id;
          this.selectedPayment = this.paymentList[0].formName;
          if (this.platformContextService.isElu()) {
            this.initPaymentDate(this.selectedPayment);
          }

          // Check if payment list contains CHQCE
          if (this.paymentList.filter(p => MoyenPaiementForm.FormEnum.ChequeRemboursement === p.formName).length > 0) {
            this.produitsService.getActivite(this.object.lignes[0].article.produit.id)
              .pipe(
                mergeMap((activity: ActiviteInterface) => this.compteBancaireService.getForReimbursement(activity.id))
              ).subscribe(compteBancaires => {
              this.compteBancaires = compteBancaires;
              this.initChequeCEAccount();
            });
          }
        }

        this.isComponentReady = true;
      });

    // On récupère les échéanciers disponibles pour la commande
    this.delegateService.getAvailableModeleEcheancier(this.object).subscribe(data => {
      this.modeleEcheancierList = data;
      this.changeModeleEcheancier();

    });
  }
  get montantReadonly() {
    return this.platformContextService.isSalarie() ||
      this.isReimboursement ||
      (this.modeleEchancier && this.modeleEchancier.impose) ||
      (this.selectedPayment === this.paymentForm.Prelevement &&
        this.modeleEcheancierList.length > 0 && this.selectedPaymentIsSepa &&
        (this.modeleEchancier !== null && (this.modeleEchancier === undefined || this.modeleEchancier.toString() !== 'null'))); // cas paiement en 1 fois
  }
  get hasModeleEcheancierNonImpose() {
    // pas fait en une ligne car find renvoie undefined si non trouvé
    if (this.modeleEcheancierList.find(me => !me.impose)) {
      return true;
    } else {
      return false;
    }
  }
  changeModeleEcheancier(payment: any = null) {
    // reset du montant au changement d'échéancier (car modifiable si paiement en 1 fois)
    if (this.object instanceof Cart) {
      this.modelPayment.montantTotal = this.object.restantApayer;
    }

    // Si un seul modele d'échéancier, et s'il est imposé, selection
    if (this.modeleEcheancierList.length === 1 && this.modeleEcheancierList[0].impose) {
      this.modeleEchancier = this.modeleEcheancierList[0];
    } else {
      // Si modèle d'échéancier, suppression date (uniquement si modele d'échéancier est en une fois)
      // if (this.modeleEchancier && this.modeleEchancier.id) {
      //   this.modelPaymentMore.date = null; // on le vide pour que l'input change de val
      // }

      if (
        (this.modeleEchancier === null || (this.modeleEchancier !== undefined && this.modeleEchancier.toString() === 'null'))
        && payment !== null
      ) {
        this.initPaymentDate(payment.formName, payment.code === 'PRLSEPA' || payment.code === 'PRLSAL', payment.code === 'PRLSAL');
      } else {
        this.modelPaymentMore.date = null;
      }

      // Si modèle d'échéancier imposé, reset du montant
      if (this.modeleEchancier && this.modeleEchancier.impose) {
        if (this.object instanceof Cart) {
          this.modelPayment.montantTotal = this.object.restantApayer;
        } else if (this.object instanceof Folder) {
          this.modelPayment.montantTotal = this.object.montantTrigger;
        }
      }
    }
  }
  resetPayment(): void {
    this.modelPaymentMore = {};
    this.initChequeCEAccount();
    this.modeleEchancier = null;
    this.formErrors = {};
  }

  /**
   * Select first account if only one in list
   */
  private initChequeCEAccount() {
    if (this.modelPayment !== undefined && this.compteBancaires !== undefined && this.compteBancaires.length === 1) {
      for (let i = 0; i < this.paymentList.length; i++) {
        if (
          MoyenPaiementForm.FormEnum.ChequeRemboursement === this.paymentList[i].formName &&
          this.modelPayment.id === this.paymentList[i].id
        ) {
          this.modelPaymentMore.compte = this.compteBancaires[0].compte.id;
        }
      }
    }
  }

  public initPaymentDate(formName: MoyenPaiementForm.FormEnum, isSepa: boolean = false, isPrlSal: boolean = false): void {
    this.selectedPayment = formName;
    this.selectedPaymentIsSepa = isSepa;
    this.selectedPaymentIsPrlSal = isPrlSal;

    const dateNow = new Date();
    let date = null;
    const dateCreation = new Date(this.object.datcre);

    // paiement le même jour que la prise de la commande
    if (this.formatDate(dateNow) === this.formatDate(dateCreation)) {
      if (
        formName === this.paymentForm.Standard ||
        formName === this.paymentForm.Cheque ||
        formName === this.paymentForm.ChequeRemboursement ||
        ((formName === this.paymentForm.Prelevement || formName === this.paymentForm.Virement) && isSepa)
      ) {
        date = this.object.date.toString();
      } else if (formName === this.paymentForm.Virement || formName === this.paymentForm.Prelevement) {
        // VIR ou PRL simples
        date = '';
      }
    } else if (this.formatDate(dateNow) > this.formatDate(dateCreation)) {
      // paiement un/plusieurs jour(s) après la prise de la commande
      if (this.paramCeDatePaiementVide) {
        date = '';
      } else {
        if (
          formName === this.paymentForm.Standard ||
          formName === this.paymentForm.Cheque ||
          formName === this.paymentForm.ChequeRemboursement ||
          ((formName === this.paymentForm.Prelevement || formName === this.paymentForm.Virement) && isSepa)
        ) {
          date = this.formatDate(dateNow);
        } else if (formName === this.paymentForm.Virement || formName === this.paymentForm.Prelevement) {
          // VIR ou PRL simples
          date = '';
        }
      }
    }

    this.modelPaymentMore.date = date;
  }

  private formatDate(date: Date): string {
    const monthTmp = date.getMonth() + 1;
    const month = monthTmp < 10 ? '0' + monthTmp.toString() : monthTmp.toString();
    const day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString();

    return date.getFullYear().toString() + '-' + month + '-' + day;
  }

  public requirePaymentDate(formName: MoyenPaiementForm.FormEnum, isSepa: boolean): boolean {
    let required = true;

    // date toujours obligatoire sauf pour un PRLSEPA avec un échéancier autre que paiement en 1 fois
    if (
      formName === this.paymentForm.Prelevement && isSepa && this.modeleEcheancierList.length > 0 &&
      this.modeleEchancier !== null && this.modeleEchancier.toString() !== 'null'
    ) {
      required = false;
    }

    return required;
  }

  onValidPayment(): void {
    const currentPayment = this.paymentList.filter(p => p.id === parseInt(this.modelPayment.id, 10))[0];
    // échéancier obligatoire uniquement pour un PRLSEPA et PRLSAL
    if (currentPayment.formName === MoyenPaiementForm.FormEnum.Prelevement && this.selectedPaymentIsSepa &&
      this.modeleEcheancierList.length > 0 && !this.modeleEchancier) {
      this.toast.createAdv({ message: 'Veuillez sélectionner un échéancier', type: 'error' });
    } else if (
      currentPayment.formName === MoyenPaiementForm.FormEnum.Cheque &&
      !this.modelPaymentMore.numeroCheque && this.platformContextService.isElu()
    ) {
      this.toast.createAdv({ message: 'Le numéro de chèque est obligatoire', type: 'error' });
    } else {
      // init and check the date depending on the payment method
      if (this.platformContextService.isElu() && !this.modelPaymentMore.date) {
        this.initPaymentDate(this.selectedPayment, this.selectedPaymentIsSepa, this.selectedPaymentIsPrlSal);
      }
      if (
        this.platformContextService.isElu() &&
        this.requirePaymentDate(this.selectedPayment, this.selectedPaymentIsSepa) &&
        (!this.modelPaymentMore.date || this.modelPaymentMore.date === '')
      ) {
        this.formErrors = {date: 'Cette valeur ne doit pas être vide.'};
        return;
      } else {
        this.formErrors = {date: ''};
      }

      this.loadingService.start();
      if (this.imageCamera) {
        this.imageCamera.file((file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          Observable.create((observer) => {
            reader.onloadend = () => {
              observer.next(reader.result);
              observer.complete();
            };
          }).subscribe((result) => {
            this.imageCamera = new Blob([result], { type: 'image/jpeg' });
            this.imageCamera.lastModifiedDate = new Date();
            this.imageCamera.name = 'cheque.jpg';
            this.validPayment();
          });
        });
      } else {
        this.validPayment();
      }
    }
  }

  validPayment(): void {
    if (this.modelPayment.id !== null) {
      const commonDataPayment = {
        moyenPaiement: this.modelPayment.id,
        consommation: this.object.id,
        montantTotal: this.modelPayment.montantTotal
      };
      if (this.modeleEchancier && this.modeleEchancier.id) {
        (commonDataPayment as any).modeleEcheancier = this.modeleEchancier.id;
      }
      if (this.imageCamera) {
        commonDataPayment['uploadedFile'] = this.imageCamera;
      }

      const dataPayment = Object.assign(commonDataPayment, this.modelPaymentMore); // merge two object

      // On est sur un formdata, les objets "null" sont remplacés par des chaines de caractères:
      // {date: null} ==> date=null <== chaine 'null'
      // On supprime donc toutes les propriétés nulles
      Object.keys(dataPayment).forEach((key) => (dataPayment[key] == null) && delete dataPayment[key]);

      this.disabledBtn = true;
      this.paymentService.setPayment(dataPayment)
        .subscribe(
          res => {
            this.handleSuccess(res)
          },
          error => this.handleErrorStatus(error)
        );
    } else {
      this.loadingService.end();
    }
  }

  private handleSuccess(res: any): void {
    this.paymentSucced.emit(res);
    this.loadingService.end();
    this.toast.create('Paiement validé', 3000, 'success');
  }

  private handleFailure(data): void {
    this.loadingService.end();
    const response = this.messageService.handleError(data);
    this.formErrors = response.formErrors;

    this.disabledBtn = false;
  }

  private handleErrorStatus(error: Response): void {
    if (error.status === 401) {
      this.paymentService.doRequest(error.url)
        .subscribe(
          res => this.handleSuccess(res),
          errorTwo => this.handleErrorStatus(errorTwo)
        );
    } else {
      this.handleFailure(error);
    }
  }

  openCamera(): void {
    const options: CameraOptions = {
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      quality: 70,
      targetWidth: 1000,
      targetHeight: 1000
    };
    this.camera.getPicture(options).then((imageData) => {
      // imageData is a base64 encoded string
      this.file.resolveLocalFilesystemUrl(imageData).then(res => {
        this.base64Image = res.toInternalURL();
        this.imageCamera = res;
        console.log(res);
      });
    }, (err) => {
      console.log(err);
    });
  }

  b64toBlob(dataURI) {
    dataURI = dataURI.replace(/^data:/, '');

    const type = dataURI.match(/image\/[^;]+/);
    const base64 = dataURI.replace(/^[^,]+,/, '');
    const arrayBuffer = new ArrayBuffer(base64.length);
    const typedArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < base64.length; i++) {
      typedArray[i] = base64.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type });
  }

  canPayLater(): boolean {
    if (this.object instanceof Cart) {
      return false === this.isFullyPaid() &&
        (
          (
            this.object.typeAcceptation === 'EXP'
            && (
              this.paiementDiffereExplicite && this.platformContextService.isSalarie() ||
              this.platformContextService.isElu()
            )
          ) ||
          (
            this.object.typeAcceptation === 'IMP' &&
            this.object.paiementDiffereImplicite !== '0' &&
            (
              this.platformContextService.isSalarie() && this.object.paiementDiffereImplicite === '2' ||
              this.platformContextService.isElu() && (
                this.object.paiementDiffereImplicite === '1' || this.object.paiementDiffereImplicite === '2'
              )
            )
          )
        );
    } else {
      return true;
    }
  }

  isFullyPaid(): boolean {
    if (this.object instanceof Cart) {
      return this.object.restantApayer === 0;
    } else {
      return Folders.StatusAdministratifEnum.Paye === this.object.statutAdministratif;
    }
  }

  chequeRemboursementCompteChanged() {
    // Si cheque activé, le compte est obligatoire
    let chequeOk = false;
    if (this.paymentList.length > 0) {
      const currentPayment = this.paymentList.filter(p => p.id === parseInt(this.modelPayment.id, 10))[0];
      if (currentPayment.formName === MoyenPaiementForm.FormEnum.ChequeRemboursement) {
        chequeOk = this.modelPaymentMore.compte != null;
      } else {
        chequeOk = true;
      }
    } else {
      chequeOk = true;
    }
    this.disabledBtn = !chequeOk;
  }

  canPay(): boolean {
    if (this.object instanceof Cart) {
      return false === this.isFullyPaid() && this.paymentList.length > 0;
    } else {
      return Folders.StatusAdministratifEnum.Paye !== this.object.statutAdministratif && this.platformContextService.isElu();
    }
  }

  canCancel(): boolean {
    if (this.object instanceof Cart) {
      return false === this.canPayLater() && true === this.object.cancelable;
    } else {
      return false;
    }
  }

  canDisplayPaymentList(): boolean {
    if (this.object instanceof Cart) {
      return false === this.isFullyPaid() &&
        (
          this.platformContextService.isSalarie() &&
          (
            (this.object.typeAcceptation === 'EXP' && this.paiementDiffereExplicite)
            || (this.object.typeAcceptation === 'IMP')
          ) ||
          (this.platformContextService.isElu())
        );
    } else {
      return Folders.StatusAdministratifEnum.Paye !== this.object.statutAdministratif && this.platformContextService.isElu();
    }
  }

  onPayLater(): void {
    this.paidLater.emit();
  }

  onCancel(): void {
    this.canceled.emit();
  }

  getButtons() {
    const canCloseOrContinue = !this.canPayLater() && true === this.isFullyPaid();
    const helpPurgeMessage = `Votre commande est déjà enregistrée et comptabilisée.
        Si vous quittez maintenant l’application sans enregistrer son règlement elle sera supprimée automatiquement dans 10’.
        En cas de problème dans l’enregistrement du paiement,
        vous pouvez la retrouver dans votre historique de commande pendant 10’ uniquement.`;
    const helpPurgeMessageElu = `Votre commande est déjà comptabilité (facturée).
        Si vous quittez maintenant cette transaction sans enregistrer son règlement elle sera supprimée dans 10’.`;

    return [
      {
        context: 'all',
        conditionDisplay: this.canPay(),
        conditionLabel: this.platformContextService.isSalarie(),
        labelIf: 'Payer ma commande',
        labelElse: 'Valider le paiement',
        action: 'onValidPayment',
        disabled: this.disabledBtn,
        class: '',
      },
      {
        context: 'all',
        conditionDisplay: this.canPayLater(),
        conditionLabel: true,
        labelIf: 'Payer plus tard',
        action: 'onPayLater',
        class: 'secondary',
        helpMessage: this.platformContextService.isSalarie() ?
          'Vous pourrez payer votre commande au CE ou la retrouver dans votre historique pour la régler en ligne selon les modalités du CE'
          : false,
        helpAction: false
      },
      {
        context: 'salarie',
        conditionDisplay: !this.canPayLater && this.canCancel(),
        conditionLabel: true,
        labelIf: 'Annuler la commande',
        action: 'onCancel',
        class: 'secondary',
        helpMessage: 'Votre commande sera automatiquement supprimée si vous n’enregistrez pas son règlement dans les 10’',
        helpAction: helpPurgeMessage
      },
      {
        context: 'all',
        conditionDisplay: this.canCancel(),
        conditionLabel: true,
        labelIf: 'Annuler la commande',
        action: 'onCancel',
        class: 'secondary',
        helpMessage: 'Aucun paiement différé n’est autorisé. Vous devez obligatoirement enregistrer le paiement de cette commande.',
        helpAction: helpPurgeMessageElu
      },
      {
        context: 'all',
        conditionDisplay: canCloseOrContinue,
        conditionLabel: this.platformContextService.isSalarie(),
        labelIf: 'Fermer',
        labelElse: 'Continuer',
        action: 'onPayLater',
        class: 'secondary'
      },
    ];
  }

  public goToPayline() {
    this.navCtrl.push('PaylinePage');
  }
}



// WEBPACK FOOTER //
// ./src/core/payment/payment.component.ts